let geocoder

export const geocode = options => {
  const google = (window as any).google
  if (!geocoder) {
    if (google && google.maps && google.maps.Geocoder) {
      geocoder = new google.maps.Geocoder()
    }
  }
  if (geocoder) {
    return new Promise((resolve, reject) => {
      geocoder.geocode(options, (results = [], status) => {
        switch (status) {
          case google.maps.GeocoderStatus.ZERO_RESULTS:
          case google.maps.GeocoderStatus.OK:
            return resolve(results || [])
          case google.maps.GeocoderStatus.INVALID_REQUEST:
          case google.maps.GeocoderStatus.OVER_QUERY_LIMIT:
          case google.maps.GeocoderStatus.REQUEST_DENIED:
          case google.maps.GeocoderStatus.UNKNOWN_ERROR:
          case google.maps.GeocoderStatus.ERROR:
          default:
            return reject(status)
        }
      })
    })
  }

  return Promise.reject(new Error('Google Maps Geocoder not available'))
}
